import styles from "./ClientCard.module.css";

type CardProps = {
  image: string;
  title: string;
  description: string;
};

const ClientCard = ({ image, title, description }: CardProps) => {
  return (
    <div className={styles.card}>
      <img src={image} alt="card" className={styles.cardImage} />
      <div className={styles.cardContent}>
        <h4 className={styles.cardTitle}>{title}</h4>
        <p className={styles.cardDesc}>{description}</p>
      </div>
    </div>
  );
};

export default ClientCard;
